import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { WatchlistProject } from '../../models/watchlist-project.model';
import { ItemViewContainerComponent } from '@shared/components/item-view-container.component';

@Component({
  selector: 'app-project-detail-dialog',
  imports: [MatDialogModule, MatButtonModule, MatIconModule, ItemViewContainerComponent],
  template: `
    <h2 mat-dialog-title>Project details</h2>

    <mat-dialog-content>
      <div class="detail-row">
        <app-item-view-container label="Project Name" class="detail-item">
          {{ data.projectName }}
        </app-item-view-container>

        <app-item-view-container label="Risk Score" class="detail-item">
          {{ data.sensitivityName }}
        </app-item-view-container>
      </div>

      <div class="detail-row">
        <app-item-view-container label="Location Names" class="detail-item">
          @for (location of locations; track location) {
            <div class="detail-chip">{{ location }}</div>
          }
        </app-item-view-container>

        <app-item-view-container label="Company Names" class="detail-item">
          @for (company of companies; track company) {
            <div class="detail-chip">{{ company }}</div>
          }
        </app-item-view-container>
      </div>

      <app-item-view-container label="Comment">
        {{ data.projectComment }}
      </app-item-view-container>

      <div class="detail-row">
        <app-item-view-container label="Valid From" class="detail-item">
          {{ data.activeFrom }}
        </app-item-view-container>

        <app-item-view-container label="Last Reviewed" class="detail-item">
          {{ data.updatedDate }}
        </app-item-view-container>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button mat-button mat-dialog-close cdkFocusInitial>Close</button>
    </mat-dialog-actions>
  `,
  styles: `
    .detail-row {
      display: flex;
      gap: 16px;
    }

    .detail-item {
      flex: 1;
      min-width: 0; /* Allow flex items to shrink below their content width */
    }

    .detail-chip {
      display: inline-block;
      padding: 0.25rem 0.75rem;
      margin: 0.25rem;
      border: 1px solid var(--text-80-color);
      border-radius: 8px;
    }

    mat-dialog-content {
      min-width: 500px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectDetailDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<ProjectDetailDialogComponent>);
  readonly data = inject<WatchlistProject>(MAT_DIALOG_DATA);

  locations!: string[];
  companies!: string[];

  ngOnInit(): void {
    this.locations = this.data.projectCountry ? this.data.projectCountry.split(';') : [];
    this.companies = this.data.projectCompany ? this.data.projectCompany.split(';') : [];
  }
}
